import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-health-page',
  standalone: true,
  template: 'OK',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthPageComponent {}
